import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-leftAglin",
  "use": "icon-leftAglin-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-leftAglin\"><path d=\"M96 128h832v96H96zM96 576h832v96H96zM96 352h576v96H96zM96 800h576v96H96z\" p-id=\"4236\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol